import type { ReactNode } from 'react'
import { parseTableLink } from '../utils/table-links'
import TableInlineLink from './TableInlineLink'
import TableMessageCards from './TableMessageCards'

/** Preserve the author's prose while opening table links in the current chat panel. */
export function renderTableLink(href: string, children: ReactNode) {
  const table = parseTableLink(href)
  return table ? (
    <TableInlineLink href={table.href} matterId={table.matterId} tableId={table.tableId}>
      {children}
    </TableInlineLink>
  ) : null
}

export function renderTableCards(matterId: string, tableIds: string[]) {
  return <TableMessageCards matterId={matterId} tableIds={tableIds} />
}
